import Vue from 'vue';
import moment from 'moment';

// Status 0 = Unknown
// Status 1 = Submitted (Awaiting approval)
// Status 2 = Accepted
// Status 3 = Rejected

export default Vue.component('statement-file-upload', {
  data: () => ({
    documents: [],
    api: {
      getAllDocuments: '/MyWecycle/file/ListFilesByStatementTaskId',
      accept: '/MyWecycle/file/AcceptByStatementTaskId',
      rejectModal: '/mywecycle/statement/StatementRejectDocumentModal',
      uploadModal: '/mywecycle/statement/StatementAddDocumentModal',
      isAuditorsReportRequiredForStatement: '/mywecycle/statement/IsAuditorsReportRequiredForStatement'
    },
    isZeroStatement: false,
    requiresAuditorsReport: false,
  }),
  computed: {
    allowedToUpload: function () {
      if (this.isZeroStatement) return false;

      var approvedFilesAuditorsReports = this.documents.filter(function (d) {
        return d.Status === 2 && d.Type === 2;
      });

      var approvedFilesManagementStatement = this.documents.filter(function (d) {
        return d.Status === 2 && d.Type === 3;
      });

      var hasTwoApprovedFiles = false;

      if (this.requiresAuditorsReport){
        hasTwoApprovedFiles = (
          approvedFilesManagementStatement.length >= 1 &&
          approvedFilesAuditorsReports.length >= 1
        );
      } else {
        hasTwoApprovedFiles = approvedFilesManagementStatement.length >= 1;
      }

      return !hasTwoApprovedFiles;
    },
    allowedToProceed: function () {
      if (this.isZeroStatement) return true;

      var approvedFilesAuditorsReports = this.documents.filter(function (d) {
        return d.Status === 2 && d.Type === 2;
      });

      if (!this.isExportOpen) {
        return approvedFilesAuditorsReports.length === 1;
      }

      var approvedFilesManagementStatement = this.documents.filter(function (d) {
        return d.Status === 2 && d.Type === 3;
      });

      if (this.requiresAuditorsReport){
        return (
          approvedFilesManagementStatement.length >= 1 &&
          approvedFilesAuditorsReports.length >= 1
        );
      }

      return approvedFilesManagementStatement.length >= 1;
    },
    parsedDocuments() {
      let documents = [];
      this.documents.forEach((d) => {
        d.DateTimeFormatted = moment(d.DateTime).format('DD-MM-YYYY - HH:mm');
        documents.push(d);
      });
      return documents;
    },
    isBOuser() {
      return utils.isBoUser();
    },
  },
  mounted() {
    this.updateDocumentsState();
    this.isAuditorsReportRequiredForStatement();
  },
  methods: {
    getAllDocuments() {
      var data = {};

      if (this.statementId) {
        data.Id = this.statementId;
      } else {
        console.log('Cannot access documents, no statement id available.');
        return;
      }

      $.ajax({
        url: this.api.getAllDocuments,
        type: 'GET',
        method: 'GET',
        data: data,
      }).done(
        function (resp) {
          this.documents = resp;
        }.bind(this)
      );
    },

    isAuditorsReportRequiredForStatement() {
      var data = {};

      if (this.statementId) {
        data.statementId = this.statementId;
      } else {
        return;
      }

      $.ajax({
        url: this.api.isAuditorsReportRequiredForStatement,
        type: 'GET',
        method: 'GET',
        data: data,
      }).done(
        function (resp) {
          this.requiresAuditorsReport = resp;
        }.bind(this)
      );
    },

    onAddDocumentButtonClick() {
      // Remove previously appended modal if it exists
      $('#modal-add-document-to-statement').remove();

      // Fetch modal from API
      $.ajax({
        url: this.api.uploadModal,
        type: 'GET',
        method: 'GET',
        data: {
          statementId: this.statementId,
        },
      }).done(this.onAddDocumentModal);
    },

    onAddDocumentModal(resp) {
      // Inject HTML of modal
      $('body').append(resp.Html);

      // Get reference to modal
      var $modal = window.$('#modal-add-document-to-statement');

      // Show modal
      $modal.modal('show');

      // initialize file validation
      utils.initFileUpload($modal, {
        maxFileSize: 10 * 1024, // 10 mb
        acceptedFileTypes: [
          'application/pdf', // pdf
          'image/jpeg', // jpg images
          'image/png', // png images
          'application/msword', // doc
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // docx
        ],
      });

      One.helpers('core-bootstrap-custom-file-input');

      // Bind form validation in modal
      $modal.find('form').validate({
        submitHandler: this.onAddDocumentModalSubmit,
      });
    },

    onAddDocumentModalSubmit(form) {
      var $modal = window.$('#modal-add-document-to-statement');

      const formData = new FormData($(form)[0]);

      var type;

      for (var [key, value] of formData.entries()) {
        if (key === 'StatementDocumentType') {
          type = value;
        }
      }

      if (!type) {
        console.log('No StatementDocumentType selected.');
        return;
      }

      $.ajax({
        url: $(form).attr('action') + '&type=' + type,
        type: 'POST',
        method: 'POST',
        enctype: 'multipart/form-data',
        processData: false,
        contentType: false,
        cache: false,
        data: formData,
      }).done(
        function (resp) {
          $modal.modal('hide');

          if (!resp.HasErrors) {
            // show msg
            One.helpers('notify', {
              type: 'success',
              icon: 'fa fa-check mr-1',
              message: resp.Message,
            });

            // Add added file to documents property so the Vue view gets updated.
            if (resp.File) {
              this.documents.push(resp.File);
            }
						
            $.ajax({
              url: '/mywecycle/statement/UpdateOnHoldWaitingForApproval',
              type: 'POST',
              method: 'POST',
              headers: {'Content-Type': 'application/x-www-form-urlencoded'},
              cache: false,
              data: {
                statementId: this.statementId,
              }
            })
	  
          } else {
            // show msg
            One.helpers('notify', {
              type: 'warning',
              icon: 'fa fa-exclamation-mark mr-1',
              message: resp.Message,
            });
          }
        }.bind(this)
      );
    },

    markDocumentStatus(documentId, statusCode) {
      var documents = this.documents.map(function (d) {
        if (d.Id === documentId) {
          d.Status = statusCode;
        }
        return d;
      });
      this.documents = documents;
    },

    onRejectDocumentClick(e) {
      var documentId = $(e.currentTarget).attr('data-document-id');

      //remove previously appended modal if it exists
      $('#modal-reject-document-in-statement').remove();

      // get data
      var data = {
        statementId: this.statementId,
        documentId: documentId,
      };

      // fetch modal HTML from api
      $.ajax({
        url: this.api.rejectModal,
        type: 'GET',
        method: 'GET',
        data: data,
      }).done(this.onRejectDocumentModal);
    },

    onRejectDocumentModal(resp) {
      // Inject modal in HTML
      $('body').append(resp.Html);

      // Get reference to modal
      var $modal = window.$('#modal-reject-document-in-statement');

      // Show modal
      $modal.modal('show');

      // Bind form validation to modal
      $modal.find('form').validate({
        submitHandler: this.onRejectDocumentModalSubmit,
      });
    },

    onRejectDocumentModalSubmit(form) {
      var $modal = window.$('#modal-reject-document-in-statement');

      const formData = new FormData($(form)[0]);

      var fileId;

      for (var [key, value] of formData.entries()) {
        if (key === 'fileId') {
          fileId = value;
        }
      }

      if (!fileId) {
        console.log('Unable to determine fileId');
        return;
      }

      $.ajax({
        url: $(form).attr('action'),
        type: 'PUT',
        method: 'PUT',
        enctype: 'multipart/form-data',
        processData: false,
        contentType: false,
        cache: false,
        data: formData,
      }).done(
        function (resp) {
          $modal.modal('hide');

          if (!resp.HasErrors) {
            // show msg
            One.helpers('notify', {
              type: 'success',
              icon: 'fa fa-check mr-1',
              message: resp.Message,
            });

            // Update the status of the document in this.documents so the view gets updated.
            this.markDocumentStatus(parseInt(fileId), 3); // 3 == rejected
			
          } else {
            // show msg
            One.helpers('notify', {
              type: 'warning',
              icon: 'fa fa-exclamation-mark mr-1',
              message: resp.Message,
            });
          }
        }.bind(this)
      );
    },

    onAcceptDocumentClick(e) {
      var data = {
        Id: this.statementId,
        fileId: $(e.currentTarget).attr('data-document-id'),
      };
      $.ajax({
        url: this.api.accept,
        type: 'PUT',
        method: 'PUT',
        data: data,
      }).done(
        function (resp) {
          this.onAcceptDocumentResponse(data.fileId, resp);
        }.bind(this)
      );
    },

    onAcceptDocumentResponse(fileId, resp) {
      if (!fileId) {
        console.log('No fileId provided.');
        return;
      }

      if (!resp.HasErrors) {
        // show msg
        if (resp.Message) {
          One.helpers('notify', {
            type: 'success',
            icon: 'fa fa-check mr-1',
            message: resp.Message,
          });
        }

        // Add document status in this.documents so the Vue view gets updated.
        this.markDocumentStatus(parseInt(fileId), 2); // 2 == accepted
      } else {
        // show msg
        if (resp.Message) {
          One.helpers('notify', {
            type: 'warning',
            icon: 'fa fa-exclamation-mark mr-1',
            message: resp.Message,
          });
        }
      }
    },

    updateDocumentsState() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.getAllDocuments();
          }
        });
      });

      observer.observe(this.$el);
    },
  },
});
